// Modules
import cn from 'classnames';

// Types
import type { TCardFooterProps } from './Card.type';

// Styles
import styles from './styles.module.scss'

const CardFooter = (props: TCardFooterProps) => {
	const {
		children,
		className,
		...restProps
	} = props

	const cardFooterCN = cn(styles.legion_card_footer, className)

	return (
		<div className={cardFooterCN} {...restProps}>
			{children}
		</div>
	)
}

export default CardFooter;
